import { useCallback } from 'react';
import { getDocByQuery, upsertDoc } from 'repositories/firebase';
import { COLLECTIONS } from 'constant';
import { IUser } from 'types';

export function useUser() {
  const saveUser = useCallback(async (user: IUser) => {
    try {
      const response = await upsertDoc<IUser>(COLLECTIONS.USER, user, user.id);
      if (response.success) {
        return {
          success: true,
          message: 'User saved successfully!',
          data: response.data,
        };
      } else {
        return {
          success: false,
          message: response.message || 'Failed to save user',
        };
      }
    } catch (err) {
      return {
        success: false,
        message: err instanceof Error ? err.message : 'Failed to save user',
      };
    }
  }, []);

  const fetchUserById = useCallback(async (userId: string) => {
    try {
      const fetchedUser = await getDocByQuery<IUser>(
        COLLECTIONS.USER,
        'id',
        userId
      );
      if (fetchedUser) {
        return {
          data: fetchedUser,
          error: null,
        };
      } else {
        return {
          data: null,
          error: 'User not found',
        };
      }
    } catch (err) {
      return {
        data: null,
        error: err instanceof Error ? err.message : 'Failed to fetch user',
      };
    }
  }, []);

  const updateUserById = useCallback(
    async (userId: string, userData: Partial<IUser>) => {
      try {
        const completeUserData: IUser = { ...userData, id: userId } as IUser;
        const response = await upsertDoc<IUser>(
          COLLECTIONS.USER,
          completeUserData,
          userId
        );
        if (response.success) {
          return {
            success: true,
            message: 'User updated successfully!',
            data: response.data,
          };
        } else {
          return {
            success: false,
            message: response.message || 'Failed to update user',
          };
        }
      } catch (err) {
        return {
          success: false,
          message: err instanceof Error ? err.message : 'Failed to update user',
        };
      }
    },
    []
  );
  return { fetchUserById, updateUserById, saveUser };
}
